export default "__VITE_ASSET__Kleg_$vP__"